module.exports = __webpack_public_path__ + "95873e54e55b8fe591115ac29dccdae8.MP3";